import { ADD_NEW_ROW_INSTITUTE, DELETE_ROW_INSTITUTE, INSTITUTE_HANDLE_CHANGE,
     UPDATE_EMPTY_FLAG_INSTITUTE, UPDATE_DUPLICATE_FLAG_INSTITUTE,
     GET_INSTITUTION_LIST_SUCCESS, GET_INSTITUTION_LIST_ERROR,
     RESET_INSTITUTION_DETAILS } from "../actionTypes";
import { v4 as uuidv4 } from 'uuid';

const initialState = {
    institutesDetailList: [
        {
            id:uuidv4(),
            InstituteIdentifier:"",
            ParentInstituteIdentifier:"",
            institute: "",
            StreetRoadBoxNo: "",
            StreetRoadName: "",
            CityTownName: "",
            PostCode: "",
            CountyRegionName: "",
            duplicateValueFlag: "false",
            emptyValueFlag: "false",
            ResultsTeamParentId:"",
            ResultsTeamChildId:"",
            RecogDBId:"",
            errors: {
                institute: "Please select the Institute."
            },
            showCreditPolicyButton:false
        }
    ],
    institutionApivalues: []
};

const institutesDetailsInfo = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case ADD_NEW_ROW_INSTITUTE:
                const newInstitute = {
                    id:uuidv4(),
                    InstituteIdentifier:"",
                    ParentInstituteIdentifier:"",
                    institute: "",
                    StreetRoadBoxNo: "",
                    StreetRoadName: "",
                    CityTownName: "",
                    PostCode: "",
                    CountyRegionName: "",
                    duplicateValueFlag: "false",
                    emptyValueFlag: "false",
                    ResultsTeamParentId:"",
                    ResultsTeamChildId:"",
                    RecogDBId:"",
                    errors: {
                        institute: "Please select the Institute."
                    },
                    showCreditPolicyButton:false,
                        };
                return {
                    ...newState,
                    institutesDetailList: newState.institutesDetailList.concat(newInstitute)
                }
        case DELETE_ROW_INSTITUTE:
            return {
                ...newState,
                institutesDetailList: newState.institutesDetailList.filter((item, index) => item.id !== action.id)
            }
        case INSTITUTE_HANDLE_CHANGE:
            return {
                ...newState,
                institutesDetailList: newState.institutesDetailList.map(
                    (item, i) => item.id === action.payload.index ? { ...item, institute: action.payload.value.dataValue,
                                                                                InstituteIdentifier : action.payload.value.dataID,
                                                                                ParentInstituteIdentifier:action.payload.value.ParentInstituteIdentifier,
                                                                                StreetRoadBoxNo:action.payload.value.StreetRoadBoxNo ,
                                                                                StreetRoadName:action.payload.value.StreetRoadName,
                                                                                CityTownName: action.payload.value.CityTownName,
                                                                                PostCode: action.payload.value.PostCode,
                                                                                CountyRegionName:action.payload.value.CountyRegionName,
                                                                                ResultsTeamParentId:action.payload.value.ResultsTeamParentId,
                                                                                ResultsTeamChildId:action.payload.value.ResultsTeamChildId,
                                                                                RecogDBId:action.payload.value.RecogDBId,
                                                                                showCreditPolicyButton:action.payload.value.dataValue?true:false}
                                                                                : item
                )
            }
            case UPDATE_EMPTY_FLAG_INSTITUTE:
            return {
                ...newState,
                institutesDetailList: newState.institutesDetailList.map(
                    (item, i) => item.id === action.payload.index ? { ...item, emptyValueFlag: action.payload.value }
                        : item
                )
            }
            case UPDATE_DUPLICATE_FLAG_INSTITUTE:
            return {
                ...newState,
                institutesDetailList: newState.institutesDetailList.map(
                    (item, i) => item.id === action.payload.index ? { ...item, duplicateValueFlag: action.payload.value }
                        : item
                )
            }
            case GET_INSTITUTION_LIST_SUCCESS:
            return {
                ...newState,
                institutionApivalues: [...newState.institutionApivalues,
                     ...action.payload.institutions]
            }
            case GET_INSTITUTION_LIST_ERROR:
            return  {
                ...newState,
                institutionApivalues: []
            }
            case RESET_INSTITUTION_DETAILS:
            return {
                ...newState,
                institutesDetailList: [{...initialState.institutesDetailList[0]}]
            }
        default: {
            return state;
        }
    }
};

export default institutesDetailsInfo;